import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import styled from 'styled-components';
import { parse } from 'hub-http/helpers/params';
import I18n from 'I18n';
import UIApplication from 'UIComponents/app/UIApplication';
import UIBox from 'UIComponents/layout/UIBox';
import { getAppShortlink, getCmsFreeSignupUrl } from 'ecosystem-marketplace-core/assets/utils/urls';
import MarketingNav, { MARKETING_NAV_LANGUAGES, getMarketingNavLanguagesContent } from 'marketplace-ui-common/components/MarketingNav';
import { getThemeDetailsSlug } from 'marketplace-assets-base/selectors/themeDetails';
import { getPublicRootUrl } from 'marketplace-assets-base/utils/urls';
const StyledUIApplication = styled(UIApplication).withConfig({
  displayName: "AppContainer__StyledUIApplication",
  componentId: "sc-1iz9e71-0"
})(["display:flex;flex-direction:column;"]);
const StyledMainContent = styled(props => /*#__PURE__*/_jsx(UIBox, Object.assign({}, props, {
  grow: 1,
  shrink: 1
}))).withConfig({
  displayName: "AppContainer__StyledMainContent",
  componentId: "sc-1iz9e71-1"
})(["min-height:100vh;"]);

const AppContainer = ({
  children,
  name
}) => {
  const {
    pathname,
    search
  } = useLocation();
  const query = parse(search.slice(1));
  const themeDetailsSlug = useSelector(getThemeDetailsSlug) || undefined;
  const hydratedLanguagesContent = useMemo(() => {
    return getMarketingNavLanguagesContent(Object.keys(MARKETING_NAV_LANGUAGES).reduce((final, languageCode) => {
      final[languageCode] = `${getPublicRootUrl(languageCode)}${pathname}${search}`;
      return final;
    }, {}));
  }, [pathname, search]);
  const headerContentBlob = useMemo(() => {
    return {
      upperNavContent: {
        loginUrl: getAppShortlink({
          pathname,
          query,
          theme: themeDetailsSlug
        }),
        regionalDropdownContent: {
          languagesContent: hydratedLanguagesContent
        }
      },
      mobileNavContent: {
        languagesContent: hydratedLanguagesContent
      },
      navCta: {
        navCtaUrl: getCmsFreeSignupUrl(themeDetailsSlug),
        navCtaText: I18n.text('marketplace-assets-ui.storefront.publicNav.navCtaText')
      }
    };
  }, [hydratedLanguagesContent, pathname, query, themeDetailsSlug]);
  return /*#__PURE__*/_jsx(StyledUIApplication, {
    name: name,
    children: /*#__PURE__*/_jsx(MarketingNav, {
      enableConvertFlag: true,
      headerContentBlob: headerContentBlob,
      children: /*#__PURE__*/_jsx(StyledMainContent, {
        children: children
      })
    })
  });
};

export default AppContainer;